import { currentUserSelector } from '@Store/selectors/userInfoSelector';
import RequestType from '@Types/common/RequestTypes';
import { RequestType as RequestTypeEnum } from '@Enum/index';
import { useAppSelector } from '.';

const parseUserList = (userList: string, empNumber: string): boolean => {
  if (userList?.length) {
    return Boolean(
      userList.split(',').find((user) => user.trim() === empNumber)
    );
  }

  return true; // if no users will mean full access for all users
};

const useHasAccessToSubmit = (requestType: RequestType): boolean => {
  const currentUser = useAppSelector(currentUserSelector);

  if (requestType === RequestTypeEnum.IT_REQUISITION) {
    const usersList = JSON.parse(
      sessionStorage.getItem('api_url')!
    )?.USERS_IT_ACCESS_SUBMIT;

    return parseUserList(usersList, currentUser?.empNumber);
  }

  if (requestType === RequestTypeEnum.RESIGNATION) {
    const usersList = JSON.parse(
      sessionStorage.getItem('api_url')!
    )?.USERS_RES_ACCESS_SUBMIT;

    return parseUserList(usersList, currentUser?.empNumber);
  }

  return true;
};

export default useHasAccessToSubmit;
